import { types } from '../types/types'
import { initialCreateBudgetNew } from '../../helpers/pptos'

const initialData = initialCreateBudgetNew()

const initialState = {
    detail: initialData,
    list: []
}

export const pptoGastoReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.pptoCargarLista:
            return {
                ...state,
                list: [...action.payload]
            }

        case types.pptoSetInfo:
            return {
                ...state,
            }

        case types.budgetsLoadDetail:
            return {
                ...state,
                detail: action.payload
            }

        case types.budgetsAddItem:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    items: [...state.detail.items, action.payload]
                }
            }

        case types.budgetsLoadItems:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    items: action.payload
                }
            }

        case types.budgetsUpdateTotales:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    total_ppto: action.payload.total_ppto
                }
            }

        case types.budgetsSetNewIds:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id: action.payload.id,
                    numero: action.payload.numero
                }
            }

        case types.budgetsUpdateDatosInicialesNotSave:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id_cliente: action.payload.id_cliente,
                    cliente: action.payload.cliente,
                    referencia: action.payload.referencia,
                    id_area_negocio: action.payload.id_area_negocio,
                    area_negocio: action.payload.area_negocio,
                    id_ejecutivo: action.payload.id_ejecutivo,
                    ejecutivo: action.payload.ejecutivo,
                    id_moneda: action.payload.id_moneda,
                    moneda: action.payload.moneda,
                    contacto_id: action.payload.contacto_id,
                    contacto_nombre: action.payload.contacto_nombre,
                    contacto_email: action.payload.contacto_email,
                    fecha_asignacion_ini: action.payload.fecha_asignacion_ini,
                    fecha_asignacion_fin: action.payload.fecha_asignacion_fin,
                    validacion_id_regla: action.payload.validacion_id_regla,
                    validacion_rentabilidad_optima: action.payload.validacion_rentabilidad_optima,
                    validacion_descripcion_regla: action.payload.validacion_descripcion_regla,
                    valor_tipo_cambio: action.payload.valor_tipo_cambio,
                    temporalidad: action.payload.temporalidad,
                    total_asignado: action.payload.total_asignado
                }
            }

        case types.budgetsUpdateCondicionesNotSave:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id_forma_pago: action.payload.id_forma_pago,
                    forma_pago: action.payload.forma_pago,
                    fecha_vencimiento: action.payload.fecha_vencimiento,
                    observaciones: action.payload.observaciones
                }
            }

        case types.budgetsUpdateMontosFinalNotSave:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    descuento: action.payload.descuento,
                    descuento_porcentaje: action.payload.descuento_porcentaje,
                    total_cliente: action.payload.total_cliente,
                    afecto: action.payload.afecto,
                    total_impuesto: action.payload.total_impuesto,
                    total: action.payload.total,
                    total_utilidad_p: action.payload.total_utilidad_p,
                    margen_gasto_p: action.payload.margen_gasto_p,
                    margen_utilidad_p: action.payload.margen_utilidad_p
                }
            }

        case types.budgetsUpdateValidationStatus:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    validacion_estado: action.payload.validacion_estado,
                    validacion_nota: action.payload.validacion_nota
                }
            }

        case types.budgetsSetIsTemplate:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    is_template: action.payload,
                }
            }


        default:
            return state;
    }

}
